import apiClient from './client';
import { API_ENDPOINTS } from './config';
import type { StaffEarningsQueryParams, StaffEarningsResponse } from '../types/staffEarnings';

const buildQuery = (params: StaffEarningsQueryParams): string => {
	const qs = new URLSearchParams();
	if (params.period) qs.set('period', params.period);
	if (params.dateFrom) qs.set('dateFrom', params.dateFrom);
	if (params.dateTo) qs.set('dateTo', params.dateTo);
	if (params.service) qs.set('service', params.service);
	if (params.status) qs.set('status', params.status);
	if (params.page != null) qs.set('page', String(params.page));
	if (params.size != null) qs.set('size', String(params.size));
	const s = qs.toString();
	return s ? `?${s}` : '';
};

export const staffEarningsApi = {
	getEarnings: async (params: StaffEarningsQueryParams = {}): Promise<StaffEarningsResponse> => {
		return apiClient.get<StaffEarningsResponse>(
			`${API_ENDPOINTS.STAFF.EARNINGS}${buildQuery(params)}`
		);
	},
};
